import { isContactIdFallbackEnabled } from './statsig';

// Keep the legacy window alias for existing integrations, but never let an
// unwritable property take down the form or discard its contact identifier.
let lastContactId;
let useLocalValue = false;

export function setContactId(value) {
  if (!isContactIdFallbackEnabled()) {
    window.contact_id = value;
    return;
  }
  lastContactId = value;
  try {
    window.contact_id = value;
    // Some Window implementations silently ignore an unwritable assignment.
    useLocalValue = window.contact_id !== value;
  } catch {
    useLocalValue = true;
  }
}

export function getContactId() {
  if (!isContactIdFallbackEnabled()) return window.contact_id;
  if (useLocalValue) return lastContactId;
  try {
    return window.contact_id;
  } catch {
    return lastContactId;
  }
}
